import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Briefcase,
  Wallet,
  Phone,
  FileText,
} from "lucide-react";

const EmergencyContact = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    employee_uuid: "",
    contact_type: "emergency",
    full_name: "",
    relationship: "",
    phone: "",
    email: "",
    address: "",
    priority: 1,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePrevious = () => {
    navigate("/hr/employee/add/salary");
  };

  const handleNext = () => {
    console.log("Emergency Contact Data:", formData);

    navigate("/hr/employee/add/documents");
  };

  return (
    <div className="p-8 bg-slate-50 min-h-screen">


       <h1 className="text-5xl font-bold text-slate-900">
        Emergency Contact
      </h1>

      <p className="text-slate-500 text-xl mt-2 mb-8">
        Step 4 of Employee Creation
      </p>
      {/* Stepper */}
      <div className="bg-white border rounded-2xl p-6 mb-8">
        <div className="flex items-center justify-between">

          <div className="flex flex-col items-center">
            <User className="text-green-600" />
            <span>Personal</span>
          </div>

          <div className="flex-1 h-1 bg-green-600 mx-4"></div>

          <div className="flex flex-col items-center">
            <Briefcase className="text-green-600" />
            <span>Employment</span>
          </div>

          <div className="flex-1 h-1 bg-green-600 mx-4"></div>

          <div className="flex flex-col items-center">
            <Wallet className="text-green-600" />
            <span>Salary</span>
          </div>

          <div className="flex-1 h-1 bg-green-600 mx-4"></div>

          <div className="flex flex-col items-center">
            <Phone className="text-blue-600" />
            <span className="text-blue-600 font-semibold">
              Emergency
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-300 mx-4"></div>

          <div className="flex flex-col items-center">
            <FileText className="text-slate-400" />
            <span>Documents</span>
          </div>

        </div>
      </div>

      

      {/* Form */}
      <div className="bg-white border rounded-2xl p-8">

        <div className="grid grid-cols-2 gap-6">

          <input
            type="text"
            name="employee_uuid"
            placeholder="Employee UUID"
            value={formData.employee_uuid}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="contact_type"
            value={formData.contact_type}
            readOnly
            className="border rounded-xl p-4 bg-slate-100"
          />

          <input
            type="text"
            name="full_name"
            placeholder="Full Name"
            value={formData.full_name}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="relationship"
            placeholder="Relationship"
            value={formData.relationship}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <textarea
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            rows="4"
            className="border rounded-xl p-4 col-span-2"
          />

          <select
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            className="border rounded-xl p-4"
          >
            <option value={1}>Primary Contact</option>
            <option value={2}>Secondary Contact</option>
            <option value={3}>Third Contact</option>
          </select>

        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-10">

          <button
            onClick={handlePrevious}
            className="px-8 py-3 border border-slate-300 rounded-xl hover:bg-slate-100"
          >
            ← Previous
          </button>

          <button
            onClick={handleNext}
            className="px-8 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700"
          >
            Next →
          </button>

        </div>

      </div>
    </div>
  );
};

export default EmergencyContact;